module.exports = __webpack_public_path__ + "img/public/SiteIcons/export.svg?2578cc6b";